import React from 'react';
import './ShimmerCell.scss';

interface ShimmerCellProps {
  width?: string;
  height?: string;
}

const ShimmerCell: React.FC<ShimmerCellProps> = ({ width = '100%', height = '16px' }) => {
  return (
    <div className="shimmer-cell" style={{ width, height }} />
  );
};

export default ShimmerCell;
